import styled, { css } from 'styled-components';

const Ball = styled.span`
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
  ${(props) =>
    !!props.backgroundColor &&
    css`
      background-color: ${props.backgroundColor};
    `}
`;

export default Ball;
